<template>
  <el-alert
    v-if="visible"
    class="referral-bind-banner"
    type="warning"
    :closable="true"
    show-icon
    @close="dismiss"
  >
    <template #title>您尚未绑定礼券</template>
    绑定后可获得相应礼遇。新用户请用<strong>注册链接</strong>（注册时自动绑券）；已注册用户请用<strong>绑定链接</strong>。
    <el-button type="primary" size="small" link @click="goBind">立即绑定</el-button>
  </el-alert>
</template>

<script>
import { isLoggedIn } from '@/utils/loginFlow'
import { fetchReferralBindStatus } from '@/utils/referralCoupon'

const DISMISS_KEY = 'referral_bind_banner_dismissed_until'

export default {
  name: 'ReferralBindBanner',
  data() {
    return {
      visible: false
    }
  },
  watch: {
    '$route.path'() {
      this.check()
    }
  },
  mounted() {
    this.check()
  },
  methods: {
    async check() {
      const path = this.$route.path
      if (!isLoggedIn() || path.startsWith('/admin') || path === '/referral/bind-coupon' || path === '/login' || path === '/register') {
        this.visible = false
        return
      }
      const dismissed = Number(sessionStorage.getItem(DISMISS_KEY) || 0)
      if (dismissed > Date.now()) {
        this.visible = false
        return
      }
      try {
        const st = await fetchReferralBindStatus()
        this.visible = !st.hasBinding && st.canBind
      } catch {
        this.visible = false
      }
    },
    dismiss() {
      sessionStorage.setItem(DISMISS_KEY, String(Date.now() + 3600000))
      this.visible = false
    },
    goBind() {
      this.$router.push('/referral/bind-coupon')
    }
  }
}
</script>

<style scoped>
.referral-bind-banner {
  margin: 0;
  border-radius: 0;
}
</style>
